export default __webpack_public_path__ + "static/media/update-icon.3287a10b.svg";